import { Grid, Typography } from '@mui/material';
import React from 'react';
import Divider from '../../../../components/Divider';
import { PricingType } from '../../../../store/reducers/GetRates/Type';
import { getDutyCharge } from '../../../../utils/pricing';

interface PropsType {
  pricing: PricingType[];
  totalPricing: number;
  taxPricing: PricingType[];
  currency: string;
  dutyChargeAmount?: number;
  isDDP?: boolean;
}

export default function ChargesBreakup({
  pricing,
  totalPricing,
  taxPricing,
  currency,
  dutyChargeAmount,
  isDDP,
}: PropsType) {
  const extractedDuty = getDutyCharge(pricing);
  // Fallback to dutyChargeAmount if pricing does not contain dutyCharge (for older responses)
  const effectiveDuty = extractedDuty > 0 ? extractedDuty : dutyChargeAmount || 0;
  const finalTotalPricing = isDDP !== false ? totalPricing : Math.max(0, totalPricing - effectiveDuty);

  console.info({ pricing });

  return (
    <Grid container rowSpacing={1}>
      <Grid container item justifyContent={'center'}>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          Breakup
        </Typography>
      </Grid>

      <Grid item xs={12} rowSpacing={1}>
        {pricing.map((price, ind) => (
          <Grid key={`charges-breakup-${ind}`} container item xs={12} className="mb-1">
            <Grid item xs={8}>
              {price.displayKey}
            </Grid>
            <Grid container item xs={4} justifyContent={'end'}>
              {`${currency} ${parseFloat(price?.value?.toString())?.toFixed(2)}`}
            </Grid>
          </Grid>
        ))}

        {taxPricing.map((price, ind) => (
          <Grid key={`tax-breakup-${ind}`} container item xs={12} className="mb-1">
            <Grid item xs={8}>
              {price.displayKey}
            </Grid>
            <Grid container item xs={4} justifyContent={'end'}>
              {`${currency} ${parseFloat(price?.value?.toString())?.toFixed(2)}`}
            </Grid>
          </Grid>
        ))}

        {/* TODO: Fallback for older cached responses where dutyCharge was not included in pricing[] */}
        {extractedDuty === 0 && dutyChargeAmount !== undefined && dutyChargeAmount > 0 && (
          <Grid container item xs={12} className="mb-1">
            <Grid item xs={8}>
              Duty Charge
            </Grid>
            <Grid container item xs={4} justifyContent={'end'}>
              {`${currency} ${parseFloat(dutyChargeAmount.toString()).toFixed(2)}`}
            </Grid>
          </Grid>
        )}
      </Grid>

      <Divider style={{ borderBottomStyle: 'dashed' }} />

      <Grid container item>
        <Grid item xs={8}>
          Total Charges
        </Grid>

        <Grid container item xs={4} justifyContent={'end'}>
          {finalTotalPricing ? `${currency} ${parseFloat(finalTotalPricing.toString()).toFixed(2)}` : ''}
        </Grid>
      </Grid>
    </Grid>
  );
}
